module.exports = __webpack_public_path__ + "fonts/rockwell-condensed.ea819b9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/what-the-fox-say/fonts/rockwell-condensed.woff
// module id = 407
// module chunks = 0